import styled from 'styled-components'

export const OrderDetailsHeader = styled.h3`
  font-size: 20px;
  margin-bottom: 20px;
`

export const OrderDetails = styled.div`
  margin-bottom: 16px;
  line-height: 125%;
`

export const OrderDetail = styled.div`
  display: flex;
  margin-bottom: 8px;
  justify-content: flex-start;
`

export const OrderDetailType = styled.span`
  flex: 0 0 105px;
  @media (min-width: 600px) {
    width: 105px;
  }
`

export const OrderTotal = styled.h3`
  display: inline;
  margin-bottom: 0;
  text-align: right;
  margin-left: auto;
  @media (min-width: 600px) {
    text-align: left;
    margin-left: 0;
  }
`

export const OrderDetailStrong = styled.strong`
  text-transform: uppercase;
  text-align: right;
  margin-left: auto;
  word-break: break-word;
  @media (min-width: 600px) {
    text-align: left;
    margin-left: 0;
  }
`

export const OrderHint = styled.div`
  margin-left: 5px;

  @media (min-width: 992px) {
    margin-left: 10px;
  }
`
